import { Box, Checkbox } from '@mui/material';

export default function MUICheckbox({ checked = false, onChange = (event) => console.log('Checkbox clicked', event), textSize = null }) {
    return (
        <Box>
            <Checkbox
                checked={checked}
                onChange={onChange}
                size="small"
                sx={{ '& .MuiSvgIcon-root': { fontSize: textSize } }}
            />
        </Box>
    );
}
